<template>
  <div>

    <div>
      <div class="title">{{ datas.tag }}
        <!-- 时间筛选 -->
        <div class="time">
          <el-select v-model="datas.days" placeholder="请选择" size="mini" style="width: 160px;" @change="changeSelect">
            <el-option v-for="item in datas.data" :key="item.k" :label="item.k" :value="item.days">
            </el-option>
          </el-select>
        </div>
      </div>
      <!-- 图表 -->
      <div class="echarts" v-if="datas.show">
        <echarts :option="datas.pieOption" />
      </div>
    </div>
  </div>
</template>
<script>
import { pieOption } from '@/utlis/echartsOption'
export default {
  props: {
    datas: { type: Object },

  },
  data() {
    return {
      show: true,
      pieOption,

    };
  },
  created() {

  },
  mounted() {
    this.datas.show = false
    this.$nextTick(() => {
      this.setPieEcharts()
    }, 1000);
  },
  methods: {

    //切换日期格式
    changeSelect(e) {
      console.log(e);
      this.datas.days = e
      this.$forceUpdate()
      // 隐藏重新加载图标
      this.datas.show = false
      this.$nextTick(() => {
        this.setPieEcharts()
      }, 1000);
    },
    // 饼图
    setPieEcharts() {

      this.datas.pieOption = JSON.parse(JSON.stringify(this.pieOption)) // 复制模板
      this.datas.pieOption.legend = {
        orient: 'vertical',
        right: 10,
        bottom: 10,
        data: ['活跃客户', '不活跃客户'],
        icon: 'circle',
      }
      this.datas.pieOption.series = [
        {
          name: '活跃客户数',
          type: 'pie',
          radius: ['50%', '85%'],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: true,
              position: 'center',
              color: '#4c4a4a',
              formatter: '',
              rich: {
                total: {
                  fontSize: 35,
                  fontFamily: "微软雅黑",
                  color: '#000'
                },
                active: {
                  fontFamily: "微软雅黑",
                  fontSize: 12,
                  color: '#999',
                  lineHeight: 30,
                },
                people: {
                  fontSize: 12,
                  fontFamily: "微软雅黑",
                  color: '#999'
                },
              }
            },
            emphasis: {//中间文字显示
              show: true,
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '30',
              fontWeight: 'bold'
            },
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          labelLine: {
            show: true
          },
          data: []
        }
      ]
      this.datas.data.forEach((item, i) => {
        if (this.datas.days == item.days) {
          this.datas.pieOption.series[0].data = [
            { value: item.rageList.inactive, name: '不活跃客户' },
            { value: item.rageList.active, name: '活跃客户' },
          ]
          this.datas.pieOption.series[0].label.normal.formatter = '{active|总人数}' + '\n\r' + '{total|' + item.rageList.all + '}' + '{people|人' + '}'

        }

      })
      this.datas.show = true

    },

  }
}
</script>

<style lang='scss' scoped>
.echarts {
  width: 96%;
}


.title {
  display: flex;
  justify-content: space-between;
}
</style>